import { useState } from "react";
import { toast } from "sonner";
import { Loader2, MinusCircle, X } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api } from "../lib/api";

export const BulkMudadBar = ({ selected, setSelected, visibleIds, onDone }) => {
  const [amount, setAmount] = useState("");
  const [busy, setBusy] = useState("");
  const vis = new Set(visibleIds);
  const selVisible = [...selected].filter((id) => vis.has(id));
  const n = selVisible.length;

  const apply = async (ids, mode) => {
    const v = Number(amount);
    if (amount === "" || Number.isNaN(v) || v < 0) { toast.warning("أدخل مبلغ خصم مدد صحيح"); return; }
    if (!ids.length) { toast.warning("لا توجد رواتب"); return; }
    if (!window.confirm(`تطبيق خصم مدد بمبلغ ${v} ريال على ${ids.length} موظف؟ سيتم استبدال القيمة الحالية.`)) return;
    setBusy(mode);
    try {
      const r = await api.bulkMudad(ids, v);
      toast.success(`تم تطبيق خصم مدد على ${r.updated} موظف`);
      setSelected(new Set()); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التطبيق"); } finally { setBusy(""); }
  };

  return (
    <div data-testid="bulk-mudad-bar" className="flex flex-wrap items-center gap-2 rounded-2xl border border-rose-100 bg-rose-50/40 p-2">
      <span className="text-sm font-semibold text-rose-700 flex items-center gap-1"><MinusCircle className="h-4 w-4" /> خصم مدد جماعي</span>
      <Input type="number" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="المبلغ" className="h-9 w-28 bg-white text-sm" data-testid="bulk-mudad-amount" />
      <Button size="sm" className="h-9 gap-1.5 bg-rose-600 hover:bg-rose-700" disabled={!n || !!busy} onClick={() => apply(selVisible, "sel")} data-testid="bulk-mudad-apply-selected">
        {busy === "sel" && <Loader2 className="h-4 w-4 animate-spin" />} تطبيق على المحددين ({n})
      </Button>
      <Button size="sm" variant="outline" className="h-9 gap-1.5 border-rose-300 bg-white text-rose-700" disabled={!visibleIds.length || !!busy} onClick={() => apply(visibleIds, "all")} data-testid="bulk-mudad-apply-all">
        {busy === "all" && <Loader2 className="h-4 w-4 animate-spin" />} تطبيق على كل الظاهرين ({visibleIds.length})
      </Button>
      {n > 0 && <button className="text-slate-400 hover:text-slate-600" onClick={() => setSelected(new Set())} data-testid="bulk-mudad-clear"><X className="h-4 w-4" /></button>}
    </div>
  );
};
